import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faInstagram, faFacebook, faApple, faGooglePlay, faYoutube } from '@fortawesome/free-brands-svg-icons';
import logo from '../../imagens/logoInformezzBranco.svg';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="container">
          <div className="footer__grid">
            {/* Coluna 1 - Sobre */}
            <div className="footer__column">
              <img src={logo} alt="Informezz" className="footer__logo" />
              <p className="footer__description">
                Com mais de 20 anos de experiência, somos referência em
                soluções tecnológicas para o varejo de moda, potencializando
                lojas de roupas e calçados em todo o Brasil.
              </p>
              <div className="footer__social">
                <a
                  href="https://www.instagram.com/Informezz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label="Instagram"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a
                  href="https://www.facebook.com/people/Informezz-Sistemas/61557268662997/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label="Facebook"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a
                  href="https://www.youtube.com/@Informezz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label="YouTube"
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
                <a
                  href="https://wa.me/5546991107619"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label="WhatsApp"
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
              </div>
            </div>

            {/* Coluna 2 - Links Rápidos */}
            <div className="footer__column">
              <h3 className="footer__title">Links Rápidos</h3>
              <ul className="footer__links">
                <li>
                  <button onClick={() => scrollToSection('funcionalidades')}>
                    Funcionalidades
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('sobre-nos')}>
                    Sobre Nós
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('contato')}>
                    Contato
                  </button>
                </li>
                <li>
                  <button onClick={() => navigate('/politica-de-privacidade')}>
                    Política de Privacidade
                  </button>
                </li>
              </ul>
            </div>

            {/* Coluna 3 - Contato */}
            <div className="footer__column">
              <h3 className="footer__title">Contato</h3>
              <ul className="footer__contact">
                <li>
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <div>
                    <strong>Endereço</strong>
                    <span>Rua Xingu, 61 - Centro</span>
                    <span>Pato Branco - PR</span>
                  </div>
                </li>
                <li>
                  <FontAwesomeIcon icon={faPhone} />
                  <div>
                    <strong>Telefone</strong>
                    <a href="tel:+554632250131">(46) 3225-0131</a>
                  </div>
                </li>
                <li>
                  <FontAwesomeIcon icon={faWhatsapp} />
                  <div>
                    <strong>WhatsApp</strong>
                    <a href="https://wa.me/5546991107619" target="_blank" rel="noopener noreferrer">
                      (46) 99110-7619
                    </a>
                  </div>
                </li>
              </ul>
            </div>

            {/* Coluna 4 - Aplicativos */}
            <div className="footer__column">
              <h3 className="footer__title">Nossos Aplicativos</h3>
              <p className="footer__app-description">
                Baixe nosso app e tenha o controle do seu negócio na palma da mão
              </p>
              <div className="footer__app-buttons">
                <a
                  href="https://play.google.com/store/apps/details?id=com.informezz.mascapp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__app-button"
                >
                  <FontAwesomeIcon icon={faGooglePlay} />
                  <div>
                    <span>Disponível no</span>
                    <strong>Google Play</strong>
                  </div>
                </a>
                <a
                  href="https://apps.apple.com/br/app/masc/id6471785383"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__app-button"
                >
                  <FontAwesomeIcon icon={faApple} />
                  <div>
                    <span>Disponível na</span>
                    <strong>App Store</strong>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-content">
            <p className="footer__copyright">
              © {currentYear} Informezz Sistemas. Todos os direitos reservados.
            </p>
            <p className="footer__credits">
              Desenvolvido com tecnologia e dedicação para o varejo de moda
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
